import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    PurchaseInvoiceServiceProxy,
    CreateOrEditPurchaseDto,
    FindVendorOutputDto,
    DropDownLookupDto,
    FindProductOutputDto,
    CreateOrEditPurchaseDetailDto,
    TaxDto,
    CurrencyDto,
    GetPurchaseForEditInput,
    Status,
    ApplicableUnitForProduct,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-purchaseInvoice.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditPurchaseInvoiceComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('qtyInput') qtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('costInput') costInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('focQtyInput') focQtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountPercInput') itemDiscountPercInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountInput') itemDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    vendorSelectedItem: FindVendorOutputDto;
    productSelectedItem: FindProductOutputDto;
    vendors: FindVendorOutputDto[];
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];

    filterText = '';

    purchaseInvoice: CreateOrEditPurchaseDto = new CreateOrEditPurchaseDto();
    purchaseDetails: CreateOrEditPurchaseDetailDto[];
    purchaseDetail: CreateOrEditPurchaseDetailDto = new CreateOrEditPurchaseDetailDto();

    vendorDisplayProperty = '';
    currencyName = '';
    paymentTermName = '';
    totalQty = 0;
    localTotal = 0;
    primaryCurrency = '';
    allCurrencys: CurrencyDto[];
    allPaymentTerms: DropDownLookupDto[];
    status = Status;
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('purchaseInvoice'), '/app/purchase/purchaseInvoices'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _purchaseInvoiceServiceProxy: PurchaseInvoiceServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.purchaseDetails.splice(index, 1);

        if (this.purchaseDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.purchaseDetails.forEach((c) => {
            c.slNo = i++;
        });

        this.productSelectedItem = null;
    }

    searchProduct(productCode: string, data: CreateOrEditPurchaseDetailDto, index: number) {
        this._commonLookupServiceProxy
            .getProductDetail(undefined, productCode, undefined, 'Purchase',0,this.appSession.user.locationId)
            .subscribe((result) => {
                if (result.productId > 0) {
                    this.focusNext('qty', index);
                    data.productId = result.productId;
                    data.cost = result.unitCost;
                    data.productName = result.productName;
                    data.productCode = result.productCode;
                    /*  data.applicableTaxes = result.applicableTaxes;*/
                    data.applicableUnits = result.applicableUnits;
                    data.unitId = result.unitId;
                    data.taxId = result.taxId;
                    data.qty = 1;
                    if (data.productSelectedItem == null) {
                        data.productSelectedItem = new FindProductOutputDto();
                        data.productSelectedItem.id = data.productId;
                        data.productSelectedItem.displayName = data.productName;
                        //this.productSelectedItem.code = result.productCode;
                    }
                    this.changeUnit(data);
                } else {
                    abp.notify.error('ProductNotFound');
                    data.productCode = '';
                }
            });
    }

    focusNext(type: 'qty' | 'cost' | 'focQty' | 'itemDiscountPerc' | 'itemDiscount' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'qty') {
            const next = this.qtyInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'cost') {
            const next = this.costInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'focQty') {
            const next = this.focQtyInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscountPerc') {
            const next = this.itemDiscountPercInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscount') {
            const next = this.itemDiscountInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.purchaseDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.purchaseDetails == null) this.purchaseDetails = [];

        this.purchaseDetail = new CreateOrEditPurchaseDetailDto();
        this.purchaseDetail.slNo = this.purchaseDetails.length + 1;
        this.purchaseDetail.itemDiscount = 0;
        this.purchaseDetail.itemDiscountPerc = 0;
        this.purchaseDetail.focQty = 0;
        this.purchaseDetail.changeUnitFlag = false;
        this.purchaseDetails.push(this.purchaseDetail);
        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }

    changeUnit(data: any): void {
        data.changeUnitFlag = true;
        this.fillDropDownUnitBasedOnProduct(data.productId, data);
    }

    fillDropDownUnitBasedOnProduct(selectProductId: number, data: CreateOrEditPurchaseDetailDto): void {
        data.applicableUnits = [];
        this._commonLookupServiceProxy.getUnitForProductCombobox(selectProductId).subscribe({
            next: (result: any) => {
                data.applicableUnits = (result.items || []).map(
                    (x: any) =>
                        new ApplicableUnitForProduct({
                            unitId: x.value,
                            name: x.displayText,
                            numberOfUnits: 0,
                            isBaseUnit: false,
                        }),
                );

                if (!(data.unitId > 0 && data.qty > 0)) {
                    data.unitId = data.unitId;
                    data.unitName = data.unitName;
                }

                let noOfUnits = 1;

                let unitCost = data.cost;

                if (unitCost > 0) {
                    data.cost = unitCost * noOfUnits;
                } else if (data.cost > 0 && noOfUnits > 0) {
                    data.cost = data.cost / noOfUnits;
                }

                this.amountCalculate(data);
                this.calculateTotalValues();
            },
            error: () => { },
        });
    }

    show(purchaseInvoiceId?: number): void {
        if (!purchaseInvoiceId) {
            this.purchaseInvoice = new CreateOrEditPurchaseDto();
            this.purchaseInvoice.id = purchaseInvoiceId;
            this.purchaseInvoice.date = this._dateTimeService.getStartOfDay();
            this.purchaseInvoice.dueDate = this._dateTimeService.getStartOfDay();
            this.purchaseInvoice.locationId = this.appSession.user.locationId;
            this.vendorDisplayProperty = '';
            this.currencyName = '';
            this.paymentTermName = '';
            this.purchaseInvoice.taxType = 1;
            this.purchaseInvoice.currencyId = null;
            this.active = true;
        } else {
            this._purchaseInvoiceServiceProxy.getPurchaseInvoiceForEdit(purchaseInvoiceId).subscribe((result) => {
                this.purchaseInvoice = result.purchase;
                this.purchaseDetails = result.purchaseDetails;
                this.purchaseDetails.forEach((c) => {
                    c.productSelectedItem = new FindProductOutputDto();
                    c.productSelectedItem.id = c.productId;
                    c.productSelectedItem.displayName = c.productName;
                });

                this.vendorSelectedItem = new FindVendorOutputDto();
                this.vendorSelectedItem.id = this.purchaseInvoice.vendorId;
                this.vendorSelectedItem.displayName = result.vendorName;

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.purchaseInvoice.id = null;
                    this.purchaseInvoice.status = this.status.Draft;
                    this.purchaseInvoice.purchaseId = purchaseInvoiceId;
                }
            });
        }
        this._commonLookupServiceProxy.getAllCurrencies().subscribe((result) => {
            this.allCurrencys = result;
        });
        this._commonLookupServiceProxy.getAllPaymentTermForTableDropdown().subscribe((result) => {
            this.allPaymentTerms = result;
        });

        this._commonLookupServiceProxy.getAllTaxes().subscribe((result) => {
            this.applicableTaxes = result;
        });
    }

    getCurrencyRate(value: any): void {
        var currency = this.allCurrencys.find((c) => c.id == value.target.value);
        var primaryCurrency = this.allCurrencys.find((c) => c.isPrimary == true);

        console.log(currency);
        this.purchaseInvoice.currencyRate = currency.rate;

        this.primaryCurrency = primaryCurrency.name;
        this.calculateTotalValues();
    }

    amountCalculate(data: CreateOrEditPurchaseDetailDto) {
        var itemDiscount = data.itemDiscount;
        var itemVendorDiscount = 0;

        let qty = data.qty;
        let cost = data.cost;

        var totalCost = parseFloat((qty * cost).toFixed(2));
        var itemDiscountPerc = 0;
        var itemDiscount = 0;

        if (data.itemDiscountPerc > 0) {
            itemDiscountPerc = (totalCost * data.itemDiscountPerc) / 100;
        }

        if (data.itemDiscount > 0) {
            itemDiscount = data.itemDiscount;
        }

        data.totalValue = parseFloat((qty * cost - itemDiscount - itemDiscountPerc).toFixed(2));
        data.subTotal = parseFloat(data.totalValue.toFixed(2));

        let taxRate = 0;
        if (data.taxId > 0) {
            var tax = this.applicableTaxes.find((p) => p.id == data.taxId);
            taxRate = tax.taxPercentage;
            data.tax = parseFloat(((data.subTotal * taxRate) / 100).toFixed(2));
            data.taxRate = taxRate;
        } else {
            data.tax = 0;
            data.taxRate = 0;
        }
        data.netTotal = parseFloat((data.subTotal + data.tax).toFixed(2));
        this.purchaseInvoice.roundingAmount = 0;
        this.purchaseInvoice.otherCharges = 0;
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        var data = this.purchaseDetails;
        var tempTotItemDiscount = 0;
        var tempTotItemDiscountPerc = 0;
        var tempTotTotalValue = 0;
        var tempTotSubTotal = 0;
        var tempTotTaxAmt = 0;
        var tempTotNetTotal = 0;
        var tempGrandTotal = 0;
        var totalQty = 0;

        var invoiceNetDiscount = this.purchaseInvoice.netDiscount;

        this.purchaseDetails.forEach((val) => {
            var itemDiscountPerc = 0;
            var totalCost = val.qty * val.cost;
            var itemDiscountPerc = 0;
            if (val.itemDiscountPerc > 0) {
                itemDiscountPerc = (totalCost * val.itemDiscountPerc) / 100;
            }

            if (invoiceNetDiscount > 0 && tempTotTotalValue > 0) {
                val.netDiscount = parseFloat(((val.totalValue * invoiceNetDiscount) / tempTotTotalValue).toFixed(2));
                val.subTotal = parseFloat(
                    (val.totalValue - (val.totalValue * invoiceNetDiscount) / tempTotTotalValue).toFixed(2),
                );
            } else {
                val.netDiscount = 0;
                val.subTotal = val.totalValue;
            }

            tempTotItemDiscount = tempTotItemDiscount + val.itemDiscount;
            tempTotItemDiscountPerc = tempTotItemDiscountPerc + itemDiscountPerc;
            tempTotTotalValue = tempTotTotalValue + val.totalValue;
            if (val.qty != 0) {
                totalQty = totalQty + val.qty;
            }

            var taxamt = 0;
            if (this.purchaseInvoice.taxType == 1) {
                taxamt = parseFloat(((val.subTotal * val.taxRate) / 100).toFixed(2));
            } else if (this.purchaseInvoice.taxType == 2) {
                var actualTotal = val.subTotal;
                if (actualTotal > 0) taxamt = (actualTotal * val.taxRate) / (val.taxRate + 100);
            }
            val.tax = parseFloat(taxamt.toFixed(2));
            if (this.purchaseInvoice.taxType == 2) {
                val.netTotal = val.subTotal;
                val.subTotal = val.netTotal - val.tax;
            } else {
                val.netTotal = val.subTotal + val.tax;
            }

            val.netTotal = val.subTotal + val.tax;
            tempTotSubTotal = tempTotSubTotal + val.subTotal;
            tempTotTaxAmt = tempTotTaxAmt + val.tax;
            tempTotNetTotal = tempTotNetTotal + val.netTotal;
        });

        this.purchaseInvoice.itemDiscount = tempTotItemDiscount;
        this.purchaseInvoice.netDiscountPerc = tempTotItemDiscountPerc;
        this.purchaseInvoice.totalValue = tempTotTotalValue;
        this.purchaseInvoice.subTotal = tempTotSubTotal;
        this.purchaseInvoice.tax = tempTotTaxAmt;
        this.purchaseInvoice.netTotal = parseFloat((this.purchaseInvoice.subTotal + this.purchaseInvoice.tax).toFixed(2));
        this.purchaseInvoice.totalQty = totalQty;

        if (this.purchaseInvoice.netDiscount > 0 && this.purchaseInvoice.netDiscount > tempTotTotalValue) {
            abp.notify.warn('DiscountInvoiceErr');
            this.purchaseInvoice.netDiscount = 0;
        }

        if (this.purchaseInvoice.roundingAmount > 0 && this.purchaseInvoice.roundingAmount > tempTotSubTotal) {
            abp.notify.warn('RoundedAmountInvoiceErr');
            this.purchaseInvoice.roundingAmount = 0;
        }

        tempGrandTotal =
            this.purchaseInvoice.netTotal +
            Number(this.purchaseInvoice.otherCharges) +
            Number(this.purchaseInvoice.roundingAmount);
        this.purchaseInvoice.grandTotal = parseFloat(tempGrandTotal.toFixed(2));
        if (!isNaN(this.purchaseInvoice.netTotal)) {
            this.localTotal = parseFloat((tempGrandTotal * Number(this.purchaseInvoice.currencyRate)).toFixed(2));
        }
    }

    save(status: any): void {
        this.saving = true;

        this.purchaseInvoice.status = status;
        var purchaseInput = new GetPurchaseForEditInput();
        purchaseInput.purchase = this.purchaseInvoice;
        purchaseInput.purchaseDetails = this.purchaseDetails;

        if (!(this.purchaseInvoice.vendorId > 0)) {
            abp.notify.warn('PleaseSelVendor');
            this.saving = false;
            return;
        }

        this._purchaseInvoiceServiceProxy
            .createOrEdit(purchaseInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/purchase/purchaseInvoices']);
            });
    }

    saveAndNew(status: any): void {
        this.saving = true;
        var purchaseInput = new GetPurchaseForEditInput();
        purchaseInput.purchase = this.purchaseInvoice;
        purchaseInput.purchaseDetails = this.purchaseDetails;
        purchaseInput.purchase.locationId = this.appSession.user.locationId;
        if (!(this.purchaseInvoice.vendorId > 0)) {
            abp.notify.warn('PleaseSelVendor');
            this.saving = false;
            return;
        }
        this._purchaseInvoiceServiceProxy
            .createOrEdit(purchaseInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.purchaseInvoice = new CreateOrEditPurchaseDto();

                this.vendorSelectedItem = null;
            });
    }

    getProduct(product: FindProductOutputDto, data: CreateOrEditPurchaseDetailDto, index: number) {
        this.productSelectedItem = product;
        this.purchaseDetails[index].productSelectedItem = product;
        this.searchProduct(product.code, data, index);
    }

    getVendor(vendor: FindVendorOutputDto) {
        this.purchaseInvoice.vendorId = vendor.id;
        this.purchaseInvoice.paymentTermId = vendor.paymentTermId;
    }

    goBack(): void {
        this._router.navigate(['/app/purchase/purchaseInvoices']);
    }
}
